// test1342
(1342 && 0);
